
<div mat-dialog-title class="fx-row fx-justify-space-between fx-items-start">
  <h1 style="margin:0">Dettaglio
    @if (trenitaliaPostSaleService.isCarnet) {
      <span>Carnet</span>
    }
    @if (!trenitaliaPostSaleService.isCarnet) {
      <span>Viaggio</span>
    }
  </h1>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
@if (trenitaliaPostSaleService.loading.value) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<!--<ng-template #trainBradcrumbs let-train="train" let-last="last">
<ng-container *ngIf="train.type == 'multi' && train.subSegments">
  <ng-container
    *ngFor="let t of train.subSegments;let last = last;"
    [ngTemplateOutlet]='trainBradcrumbs'
    [ngTemplateOutletContext]='{last:last, train:t}'
  ></ng-container>
</ng-container>
<ng-container *ngIf="train.type != 'multi'">
  <img *ngIf="trainTypeImages[train.type]" [matTooltip]="train.type" [src]="trainTypeImages[train.type]" class="train-icon"/>
  <small class="train-name"> {{train.name}}</small>
</ng-container>
<span *ngIf="!last"> / </span>
</ng-template>-->
<mat-dialog-content>

  @if (trenitaliaPostSaleService.travelDetails.value) {
    <div>
      <div class="mb-8 text-right">
        @if (dataDialog.tripBookingPackage.tour_operator_booking_status =='confirmed') {
          <button mat-raised-button [disabled]="load" (click)="sendMail()">
            <mat-icon class="s-16">email</mat-icon><span class="font-weight-600">Invia via Mail</span>
          </button>
        }
      </div>
      @for (travelSolution of travelSolutions; track travelSolution; let last = $last) {
        <mat-accordion [multi]="true">
          <trenitalia-solution-details [travelSolution]="travelSolution" [ar]="travelSolution.returnTravelSolution?'forward':'one_way'"></trenitalia-solution-details>
          @if (travelSolution.returnTravelSolution) {
            <trenitalia-solution-details [travelSolution]="travelSolution.returnTravelSolution" [ar]="'return'" ></trenitalia-solution-details>
          }
        </mat-accordion>
      }
    </div>
  }

</mat-dialog-content>